<template>
	<v-dialog v-model="dialogUser" max-width="800px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.nome"
									label="Nome"
									:rules="[rules.required, rules.min2]"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.email"
									label="E-mail"
									:rules="[rules.required, rules.min2, rules.email]"
									type="email"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.telefone"
									label="Telefone"
									v-mask="['(##) ####-####', '(##) #####-####']"
									maxlength="15"
									:rules="[rules.required]"
									type="tel"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.cpf"
									label="CPF"
									v-mask="'###.###.###-##'"
									maxlength="14"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									label="Senha"
									prepend-icon="fal fa-lock-alt"
									:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPassword ? 'text' : 'password'"
									@click:append="showPassword = !showPassword"
									v-model="codigo"
									placeholder="Digite a senha"
									autocomplete="off"
								>
								</v-text-field>
							</v-col>
							<v-col cols="12">
								<v-switch
									v-model="editedItem.admin"
									color="indigo"
									label="Administrador"
								></v-switch>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="warning" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn
					v-if="typeForm === 1"
					color="error"
					icon
					@click="archiveChoice()"
					title="Arquivar formulário"
				>
					<v-icon>fal fa-archive</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
			<OpenChoice :choice="choice" @choiceResult="choiceResult" />
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import OpenChoice from '@/components/OpenChoice'

export default {
	inheritAttrs: false,
	components: {
		OpenChoice,
	},
	props: {
		userEdit: {
			default: null,
		},
		typeForm: {
			default: 0,
		},
		cursoId: null,
	},

	data() {
		return {
			server: 'user',
			showPassword: false,
			editedItem: {
				id: 0,
				nome: '',
				cpf: '',
				email: '',
				telefone: '',
				admin: false,
			},
			codigo: null,
			choice: {
				title: 'Você tem certeza?',
				dialog: false,
			},
		}
	},
	computed: {
		...mapState(['user', 'rules', 'dialogUser']),
		formTitle() {
			return this.typeForm === 0 ? 'Cadastrar' : 'Editar'
		},
	},
	created() {
		if (this.typeForm === 1) {
			this.editedItem = Object.assign({}, this.userEdit)
			this.editedItem.admin = this.editedItem.admin == 1 ? true : false
    }
		setTimeout(() => {
			this.codigo = null
		}, 1700)
	},

	methods: {
		close() {
			this.$store.dispatch('dialogUser', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', { typeForm: 0, hideForm: 'user' })
			}, 300)
		},
		archiveChoice() {
			this.choice.dialog = true
		},
		choiceResult(value) {
			if (value === true) {
				this.archive()
			} else {
				this.$store.dispatch('alert', {
					alertMessage: 'Not archived',
					alertType: 1,
				})
			}
		},
		archive() {
      this.editedItem.archive = (this.editedItem.archive=='0')?false:true
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'archive_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('id', this.editedItem.id)
			formData.append('archive', !this.editedItem.archive)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.$store.dispatch('alert', {
							alertMessage: response.data.alertMessage,
							alertType: 0,
						})
						vd.$store.dispatch('searchUser', { value: true })
						vd.close()
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destination: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERROR!! ' + response)
				})
		},

		save() {
			if (this.$refs.form.validate()) {
				if (this.typeForm === 0) {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'insert_' + this.server)
					formData.append('user_id', this.user.id)
					formData.append('nome', this.editedItem.nome)
					formData.append('cpf', this.editedItem.cpf)
					formData.append('email', this.editedItem.email)
					formData.append('telefone', this.editedItem.telefone)
					formData.append('codigo', this.codigo)
					formData.append('admin', this.editedItem.admin)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUser', { value: true })
								vd.close()
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				} else {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'update_' + this.server)
					formData.append('user_id', this.user.id)
					formData.append('id', this.editedItem.id)
					formData.append('nome', this.editedItem.nome)
					formData.append('cpf', this.editedItem.cpf)
					formData.append('email', this.editedItem.email)
					formData.append('telefone', this.editedItem.telefone)
					formData.append('codigo', this.codigo)
					formData.append('admin', this.editedItem.admin)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.close()
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchUser', { value: true })
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				}
			}
		},
	},
}
</script>
